/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_Insert_ImageInputs */

const en_common_editor_insert_image = /** @type {(inputs: Common_Editor_Insert_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert image`)
};

const zh_common_editor_insert_image = /** @type {(inputs: Common_Editor_Insert_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入图片`)
};

/**
* | output |
* | --- |
* | "Insert image" |
*
* @param {Common_Editor_Insert_ImageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_insert_image = /** @type {((inputs?: Common_Editor_Insert_ImageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_Insert_ImageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_insert_image(inputs)
	return zh_common_editor_insert_image(inputs)
});
export { common_editor_insert_image as "common.editor.insert_image" }